export const GRAFANA_DATASOURCE_REF = {
  name: 'grafana',
  uid: 'grafana',
};

export const GRID_ROW_HEIGHT = 1;
